import { set } from 'cerebral/operators'
import redirect from 'cerebral-module-router/redirect'

export default [set('state:login.showGDPRDialog', false), redirect('/welcome')]



// WEBPACK FOOTER //
// ./src/modules/login/chains/dismissGDPR.js